<template>
  <div id="app" ref="app">

    <div v-if="(requireUser && !userLoaded) || loadingUser" class="center-screen" style="background:white;">
      <s-loader :type="'scalify'"></s-loader>
    </div>

    <component v-else :is="layout">
      <router-view :key="$route.fullPath" />
      <!-- Toast -->
      <div class="toast-container">
        <div v-for="(toast, indexToast) in this.$store.state.toasts" :key="indexToast">
          <s-toast :id="toast.id" :btn="toast.btn" :state="toast.state" :title="toast.title" :text="toast.text"></s-toast>
        </div>
      </div>
    </component>

  </div>
</template>

<script>
import Vue from 'vue'
import io from '../public/socket.io-1.4.5'
const default_layout = "default";
export default {

  name: 'app',
  components: {
  },
  data(){
    return {
      userLoaded: false
    }
  },
  methods:{
    animateValue(id, start, end, duration) {
      if (start === end) return;
      let range = end - start;
      let current = start;
      let increment = end > start? 1 : -1;
      let stepTime = Math.abs(Math.floor(duration / range));
      let obj = document.getElementById(id);
      let timer = setInterval(() => {
          current += increment;
          if(obj){
            obj.innerHTML = current;
          }
          if (current == end) {
              clearInterval(timer);
          }
      }, stepTime);
    },
    startSocket(){
      if(!this.$socket){
        Vue.prototype.$socket = io.connect("https://socket.scalify.app/",{query:`at=${this.scalifyAccessToken}`});
        let room = `super|admin`;
        this.$socket.emit("join", room);
      }
      // let event = `nbr_active_users`;
      let event = `connected_accounts`;
      this.$nextTick(()=>{
        // this.$socket.on(event, (data) => {
        //   console.log("connected users count",data)
        //   this.$store.state.currentConnectedUsers = data
        //   await this.animateValue("connectedUsers", this.$store.state.lastConnectedUsers, this.$store.state.currentConnectedUsers, 1000);
        //   this.$store.state.lastConnectedUsers = data
        // });

        this.$socket.on(event, async (data) => {
          this.$store.state.listAccounts = [...data]
          let sumSess = 0
          for(let i=0;i<data.length;i++){
            sumSess = sumSess + data[i].sessions
          }
          this.$store.state.currentConnectedUsers = sumSess
          // this.animateValue("connectedUsers", this.$store.state.lastConnectedUsers, this.$store.state.currentConnectedUsers, 1000);
          this.$store.state.lastConnectedUsers = sumSess
          this.$store.state.loadingAccounts = false
          this.$forceUpdate()
        });
        
      })
    }
  },
  computed:{
     requireUser() {
      var routesThatDontRequireUser = [
        "/login"
      ];
      return routesThatDontRequireUser.indexOf(this.$route.path) == -1;
    },
    layout() {
      return `${this.$route.meta.layout || default_layout}-layout`;
    },
    loadingUser(){
      return this.$store.state.loadingUser
    }
  },

  watch: {
    async requireUser(){
      if (this.requireUser && !this.user) {
        this.checkToken();
        if (this.user == null) {
          this.$store.state.user = await this.userData();
        }
      }
    },
    async user(){
      if (this.user != null) {
        this.userLoaded = true;
        this.startSocket()
      }
    },

  },

  async created(){
    console.log("process.env.VUE_APP_API_URL",process.env.VUE_APP_API_URL)
    // console.log('this.requireUser: ', this.requireUser);
    if (this.requireUser) {
      const token = await this.checkToken();
      if (this.user == null && token) {
        this.$store.state.user = await this.userData();
      }
    }
  },
  async mounted(){
  }

}
</script>
<style lang="scss">

</style>
